/**
 * Format a number for AAT display: + for positive, 0.00 for zero, capped at 2 decimals.
 * Avoids unbounded decimals from float precision (e.g. chart tick values).
 * Handles string inputs (e.g. from roundToTwo or i18n) by coercing to number first.
 */
function formatAATValue(num) {
  const n = Number(num);
  if (Number.isNaN(n)) {
    return 'n/a';
  }
  if (n % 1 === 0) {
    return n > 0 ? `+${n}` : String(n);
  }
  let s = n.toFixed(2);
  // Trim single trailing zero (5.50 -> 5.5) but keep .00 (e.g. 0.00)
  while (s.endsWith('0') && s.length > 2 && s[s.length - 2] !== '0') {
    s = s.slice(0, -1);
  }
  return n > 0 ? `+${s}` : s;
}

export default (num) => {
  if (num == null || (typeof num === 'string' && num.trim() === '')) {
    return 'n/a';
  }
  const n = Number(num);
  if (Number.isNaN(n)) {
    return 'n/a';
  }
  if (n > 0) {
    return formatAATValue(n);
  }
  if (n === 0) {
    return '0.00';
  }
  return formatAATValue(n);
};
